<section class="bg-white h-full overflow-hidden">

  <ng-container *ngrxLet="localStore.initialLocation$; let location">
    @if (location) {
      <div class="h-full flex flex-col">
        <!-- FIXED HEADING & TABS -->
        <div class="bg-white px-3 pt-[24px] z-50">
          <div class="flex flex-row">
            <div class="w-full">
            <p class="m-0 px-3">{{location?.storeCode}}</p>
              <h1 class="mt-0 px-3 mb-[6px]">{{location?.businessName}}</h1>
            </div>
          </div>
          <div class="flex items-center justify-start"
            *ngrxLet="localStore.uppermostVisibleSection$; let activeSection">
            @for (section of getSectionNames(); track section) {
              <div
               class="relative
                      px-3 py-2 mb-1
                      tabFont text-green-10 hover:bg-neutral-95
                      cursor-pointer
                      rounded-[4px]"
                (click)="goToSection(section)">
                <span>{{ section }}</span>
                <!-- blue underline-->
                @if (section===activeSection) {
                  <span
                  class="h-[4px] underlineWidthAndPosition
                         rounded-t-lg
                         bg-green-10"
                    [@underlineAnimation]=""
                  ></span>
                }
              </div>
            }
          </div>
          <mat-divider></mat-divider>
        </div>
        <!-- SCROLLABLE CONTENT -->
      <form class="pb-[20px]
                   flex-grow
                   overflow-y-auto overflow-x-hidden
                   intersectionRoot"
            *ngrxLet="localStore.state$; let state">
          @if (state.loading) {
            <div [attr.section-name]="'Loader'">
              <ngx-skeleton-loader count="1"
              animation="pulse"></ngx-skeleton-loader>
              <div class="max-w-[75%]">
                <ngx-skeleton-loader count="2"
                animation="pulse"></ngx-skeleton-loader>
              </div>
            </div>
          }
          @if (!state.loading) {
            <app-basic-information-section
              [sectionName]="EditLocationSection.Basic"
            ></app-basic-information-section>
            <mat-divider class="py-2"></mat-divider>
            <app-business-hours-section
              [sectionName]="EditLocationSection.Hours"
            ></app-business-hours-section>
            <mat-divider class="py-2"></mat-divider>
            <app-geo-data-section
              [sectionName]="EditLocationSection.Location"
            ></app-geo-data-section>
            <mat-divider class="py-2"></mat-divider>
            <app-media-section
              [sectionName]="EditLocationSection.Media"
            ></app-media-section>
            <mat-divider class="py-2"></mat-divider>
            <app-other-information-section
              [sectionName]="EditLocationSection.Other"
              (addCustomService)="addCustomService()"
            ></app-other-information-section>
          }
        </form>
        <div class="buttons-wrapper" *ngrxLet="localStore.state$; let state">
          @if (!state.loading && state.edited) {
            <button
                matButton="outlined"
              class="mr-2"
              type="button"
              (click)="undoChanges()">Undo changes
            </button>
          }
          <button mat-flat-button type="submit"
            [disabled]="state.saving || !localStore.formGroup?.valid || !state.edited"
            color="primary"
            (click)="attemptToSave()">
            <span class="flex items-center">
              <span>Save</span>
              @if (state.saving) {
                <mat-spinner class="ml-1" [diameter]="16"></mat-spinner>
              }
            </span>
          </button>
        </div>
      </div>
    } @else {
      <div class="flex flex-col flex-grow justify-center items-center h-full">
        <img src="assets/images/icon/location_placeholder.svg" alt="No location"
          class="w-1/2 max-w-[125px]"/>
          <p>No location selected</p>
        </div>
      }


    </ng-container>

  </section>